import { create } from "zustand";
import type { VehicleSocket } from "./vehiclesSocketStore";
import type { TrackingLink } from "./trackingLinksStore";

interface TrackingLinkModalStore {
  // Create modal state
  isOpen: boolean;
  selectedVehicle: VehicleSocket | null;
  openModal: (vehicle: VehicleSocket) => void;
  openModalWithoutVehicle: () => void;
  closeModal: () => void;
  // Details modal state
  isDetailsOpen: boolean;
  selectedTrackingLink: TrackingLink | null;
  openDetailsModal: (trackingLink: TrackingLink) => void;
  closeDetailsModal: () => void;
}

export const useTrackingLinkModalStore = create<TrackingLinkModalStore>((set) => ({
  // Create modal
  isOpen: false,
  selectedVehicle: null,
  openModal: (vehicle) => set({ isOpen: true, selectedVehicle: vehicle }),
  openModalWithoutVehicle: () => set({ isOpen: true, selectedVehicle: null }),
  closeModal: () => set({ isOpen: false, selectedVehicle: null }),
  // Details modal
  isDetailsOpen: false,
  selectedTrackingLink: null,
  openDetailsModal: (trackingLink) => set({ isDetailsOpen: true, selectedTrackingLink: trackingLink }),
  closeDetailsModal: () => set({ isDetailsOpen: false, selectedTrackingLink: null }),
}));
